import DOMPurify from "dompurify";

interface Props {
  content: string;
  className?: string;
}

const sanitizeContent = (content: string): string => {
  if (!content) return "";
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      "p", "br", "b", "strong", "i", "em", "u", "s", "strike",
      "h1", "h2", "h3", "h4", "h5", "h6",
      "ul", "ol", "li",
      "blockquote", "pre", "code",
      "a", "img", "span", "div",
      "table", "thead", "tbody", "tr", "th", "td",
      "hr",
    ],
    ALLOWED_ATTR: [
      "href", "src", "alt", "title", "target", "rel",
      "style", "class", "width", "height", "colspan", "rowspan",
    ],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
    ADD_ATTR: ["target"],
  });
};

const RichContentRenderer: React.FC<Props> = ({ content, className = "" }) => {
  const safeHtml = sanitizeContent(content);

  return (
    <div className={`rich-content ${className}`} dangerouslySetInnerHTML={{ __html: safeHtml }} />
  );
};

export default RichContentRenderer;